const THEMES = {
  "parttime-cfo": { tone: 0, motif: "cubes" },
  "esop": { tone: 1, motif: "rings" },
  "rvpc": { tone: 2, motif: "arcs" },
  "growth": { tone: 0, motif: "bars" },
  "margin": { tone: 1, motif: "grid" },
  "cashflow": { tone: 2, motif: "waves" },
  "cfo": { tone: 0, motif: "stairs" },
  "d2c-metrics": { tone: 1, motif: "hex" },
  "horeca": { tone: 2, motif: "circles" },
};

const TONES = [
  { bg: "#dde5d3", fg: "#1a5c3a" },
  { bg: "#e2ece5", fg: "#0d2b1f" },
  { bg: "#efe8d7", fg: "#c47f2a" },
];

const motifProps = (fg) => ({ stroke: fg, fill: "none", strokeWidth: 1.1, opacity: 0.4 });

const MOTIFS = {
  cubes: (fg) => (
    <svg width="150" height="130" viewBox="0 0 150 130" {...motifProps(fg)}>
      <path d="M45 55 L75 38 L105 55 L105 88 L75 105 L45 88 Z" />
      <path d="M45 55 L75 72 L105 55 M75 72 L75 105" />
      <path d="M85 20 L108 33 L108 58 L85 71 L62 58 L62 33 Z" />
      <path d="M62 33 L85 46 L108 33 M85 46 L85 71" />
    </svg>
  ),
  rings: (fg) => (
    <svg width="140" height="140" viewBox="0 0 140 140" {...motifProps(fg)}>
      <circle cx="70" cy="70" r="55" />
      <circle cx="70" cy="70" r="38" />
      <circle cx="70" cy="70" r="21" />
      <path d="M70 15 L70 49 M70 91 L70 125" />
    </svg>
  ),
  arcs: (fg) => (
    <svg width="150" height="120" viewBox="0 0 150 120" {...motifProps(fg)}>
      <path d="M10 120 A 110 110 0 0 1 120 10" />
      <path d="M35 120 A 85 85 0 0 1 120 35" />
      <path d="M60 120 A 60 60 0 0 1 120 60" />
      <path d="M85 120 A 35 35 0 0 1 120 85" />
    </svg>
  ),
  bars: (fg) => (
    <svg width="150" height="120" viewBox="0 0 150 120" {...motifProps(fg)}>
      {[0, 1, 2, 3].map((i) => (
        <rect key={i} x={12 + i * 34} y={105 - (i + 1) * 24} width="22" height={(i + 1) * 24} />
      ))}
      <path d="M4 92 L138 8" strokeDasharray="4 5" />
    </svg>
  ),
  grid: (fg) => (
    <svg width="150" height="120" viewBox="0 0 150 120" {...motifProps(fg)}>
      {[0, 1, 2, 3].map((i) => (
        <path key={`h${i}`} d={`M10 ${25 + i * 26} L140 ${12 + i * 26}`} />
      ))}
      {[0, 1, 2, 3, 4].map((i) => (
        <path key={`v${i}`} d={`M${14 + i * 30} 8 L${22 + i * 30} 112`} />
      ))}
    </svg>
  ),
  waves: (fg) => (
    <svg width="160" height="100" viewBox="0 0 160 100" {...motifProps(fg)}>
      {[0, 1, 2].map((i) => (
        <path key={i} d={`M0 ${28 + i * 24} C 32 ${10 + i * 24}, 56 ${46 + i * 24}, 88 ${28 + i * 24} S 144 ${10 + i * 24}, 160 ${28 + i * 24}`} />
      ))}
    </svg>
  ),
  stairs: (fg) => (
    <svg width="140" height="120" viewBox="0 0 140 120" {...motifProps(fg)}>
      <path d="M10 110 L10 86 L38 86 L38 62 L66 62 L66 38 L94 38 L94 14 L122 14" />
      <path d="M38 110 L38 86 M66 110 L66 62 M94 110 L94 38 M122 110 L122 14" />
      <circle cx="128" cy="10" r="4" />
    </svg>
  ),
  hex: (fg) => (
    <svg width="140" height="130" viewBox="0 0 140 130" {...motifProps(fg)}>
      <path d="M70 12 L118 40 L118 92 L70 120 L22 92 L22 40 Z" />
      <path d="M70 38 L96 54 L96 82 L70 98 L44 82 L44 54 Z" />
      <path d="M70 12 L70 38 M118 40 L96 54 M118 92 L96 82 M70 120 L70 98 M22 92 L44 82 M22 40 L44 54" />
    </svg>
  ),
  circles: (fg) => (
    <svg width="150" height="120" viewBox="0 0 150 120" {...motifProps(fg)}>
      <circle cx="55" cy="60" r="42" />
      <circle cx="98" cy="60" r="42" />
      <circle cx="76" cy="34" r="16" />
    </svg>
  ),
};

export default function ArticleArt({ slug, title, showTitle = true, className = "" }) {
  const t = THEMES[slug] || { tone: 0, motif: "cubes" };
  const tone = TONES[t.tone];
  const Motif = MOTIFS[t.motif];
  return (
    <div
      className={`relative w-full h-full overflow-hidden ${className}`}
      style={{ backgroundColor: tone.bg }}
      aria-hidden="true"
    >
      <div className="absolute -right-3 -bottom-3">{Motif && Motif(tone.fg)}</div>
      {showTitle && title && (
        <p
          className="absolute top-0 left-0 right-0 p-6 font-serif leading-[1.15] line-clamp-3"
          style={{ color: tone.fg, fontSize: "1.35rem" }}
        >
          {title}
        </p>
      )}
    </div>
  );
}
